import React from "react"
import SEO from "../components/seo"

const IndexPage = () => (
  <div>
    <SEO title="Home" />
    <div className="banner">
      <div className="inner-banner">
        <div className="container">
          <h1 className="main-headline small">Click on the menu button</h1>
        </div>
      </div>
    </div>
  </div>
)

export default IndexPage
